import { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	LoanDefinitionType,
	SecurityFeatureType,
	SecurityType,
} from '@dealstack/shared/lib/generated';
import { useCallback } from 'react';

export const useSecurityTypeTranslation = () => {
	const tDefault = useTranslationDefault();

	return useCallback(
		(securityType?: SecurityType | LoanDefinitionType) => {
			if (!securityType) {
				return '';
			}

			switch (securityType) {
				case SecurityType.LOAN: {
					return tDefault(`security_types.loan`);
				}
				case SecurityType.ORDINARY_SHARE: {
					return tDefault(`security_types.ordinary_share`);
				}
				case SecurityType.OTHER: {
					return tDefault(`security_types.other`);
				}
				case SecurityType.PREFERENCE_SHARE: {
					return tDefault(`security_types.preference_share`);
				}
				case SecurityType.TRACKING_SHARE: {
					return tDefault(`security_types.tracking_share`);
				}
				case SecurityType.PARTNERSHIP_UNIT: {
					return tDefault(`security_types.partnership_unit`);
				}
				case SecurityType.OPTIONS: {
					return tDefault(`security_types.options`);
				}
				case SecurityType.VIRTUAL_EQUITY: {
					return tDefault(`security_types.virtual_equity`);
				}
				case SecurityType.WARRANT: {
					return tDefault(`security_types.warrant`);
				}
				case SecurityType.OTHER_EQUITY: {
					return tDefault(`security_types.other_equity`);
				}
				case LoanDefinitionType.MANAGEMENT_LOAN: {
					return tDefault('loans_types.management_loan');
				}
				case LoanDefinitionType.DEFERRED_PAYMENT: {
					return tDefault('loans_types.deferred_payment');
				}
				default:
					return tDefault(`security_types.not_found`);
			}
		},
		[tDefault]
	);
};

export const useSecurityFeatureTypeTranslation = () => {
	const tDefault = useTranslationDefault();

	return useCallback(
		(featureType?: SecurityFeatureType) => {
			if (!featureType) {
				return '';
			}

			switch (featureType) {
				case SecurityFeatureType.RESIDUE: {
					return tDefault(`security_feature_types.residue`);
				}
				case SecurityFeatureType.INTEREST: {
					return tDefault(`security_feature_types.interest`);
				}
				case SecurityFeatureType.PRINCIPAL: {
					return tDefault(`security_feature_types.principal`);
				}
				case SecurityFeatureType.TRACKING: {
					return tDefault(`security_feature_types.tracking`);
				}
				case SecurityFeatureType.CATCH_UP: {
					return tDefault(`security_feature_types.catch_up`);
				}
				case SecurityFeatureType.OPTION: {
					return tDefault(`security_feature_types.option`);
				}
				case SecurityFeatureType.LIQUIDATION_PREFERENCE: {
					return tDefault(`security_feature_types.liquidation_preference`, {
						defaultValue: 'Liquidation preference',
					});
				}
				default:
					return tDefault(`security_feature_types.not_found`);
			}
		},
		[tDefault]
	);
};
